import DOMPurify from 'dompurify';

/**
 * By default, DOMPurity removes all "target" attributes from links. We
 * circumvent this issue by creating a custom hook that readds this value after
 * sanitization.
 * https://github.com/cure53/DOMPurify/tree/main/demos#hook-to-open-all-links-in-a-new-window-link
 */
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if ('target' in node) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener');
  }
});

export const sanitizeHtml = (dirty: string) => {
  return DOMPurify.sanitize(dirty);
};
